import { TemplateVisibility } from '@heidi/schema/ml-scribe';
import { useOrganizationInfo } from '@heidi/workspace/data';
import { useMemo } from 'react';
import { useTemplateFromTemplateCreationRecordId } from './useTemplateFromTemplateCreationRecordId';
import { useTemplateSharing } from './useTemplateSharing';

export const useIsNonAdminEditingOrganizationTemplate = () => {
  const template = useTemplateFromTemplateCreationRecordId();

  const { canManageOwnTeamTemplate } = useTemplateSharing();
  const { isOrganizationTemplateManager } = useOrganizationInfo();

  const isNonAdminEditingOrganizationTemplate = useMemo(() => {
    if (template?.template_visibility !== TemplateVisibility.Organization) {
      return false;
    }
    if (isOrganizationTemplateManager) {
      return false;
    }
    // Sub-team Template Managers can edit the content of Org-visibility templates
    // that originated from their team. Visibility itself stays locked in the form
    // (gated by canShareBroadly), so this can't be used to broaden reach.
    if (canManageOwnTeamTemplate(template)) {
      return false;
    }
    return true;
  }, [canManageOwnTeamTemplate, isOrganizationTemplateManager, template]);

  return {
    isNonAdminEditingOrganizationTemplate,
  };
};
